import { create } from 'zustand';

import { AnalyticsEvent, track } from '@bonusly/analytics';

import { CheckInFormData } from '../components/check-in-form';

type CheckInModalStoreProps = {
	isOpen: boolean;
	preselectedScore?: number;
	onClose: () => void;
	onOpen: (preselectedScore?: number) => void;
	onSubmit?: (formData: CheckInFormData) => void;
};

export const useCheckInModalStore = create<CheckInModalStoreProps>((set) => ({
	isOpen: false,
	preselectedScore: undefined,
	onClose: () => set({ isOpen: false, preselectedScore: undefined }),
	onOpen: (preselectedScore?: number) => {
		set({ isOpen: true, preselectedScore });
		track(AnalyticsEvent.CheckIns.ModalOpened);
	},
	onSubmit: undefined,
}));

export const useCheckInModal = () => useCheckInModalStore((state) => state);
